import React from 'react';
import GameTabUI from "./GameTabUI";
export default class GameTabViewUI extends React.Component{
    constructor() {
        super();
        this.state = {
            selectedIndex: 0
        }
    }
    selectCard(id){
        this.setState({
            selectedIndex: id
        });
        this.props.onSelectedIndex(id);
    }
    render() {
        let tabs = [];
        for(let i = 0; i < this.props.tabs.length; i++){
            tabs.push(<GameTabUI
                key={i}
                width={this.props.width / this.props.tabs.length}
                height={this.props.height}
                value={this.props.tabs[i]}
                selectedStyles={this.props.selectedStyles}
                isSelected={this.props.selectedIndex ? this.props.selectedIndex === i : this.state.selectedIndex === i}
                onClick={this.selectCard.bind(this)}
                id={i}
            >
            </GameTabUI>);
        }
        return <div style={{
            height: this.props.height,
            display:"flex",
            alignItems: "center"
        }
        }>{tabs}</div>;
    }
}
